import { makeStyles } from '@material-ui/core/styles'

const DataStyles = makeStyles(theme => ({
	layoutRoot: {}
}))

export default DataStyles
